import React from 'react'

function StarIcon({ maskWidth, ...rest }) {
  return (
    <svg
      {...rest}
      viewBox="0 0 18 18"
      height="18"
      width="18"
      focusable="false"
      role="img"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Rating Star icon</title>
      {maskWidth && (
        <defs>
          <mask id="half">
            <rect x="0" y="0" width="18" height="18" fill="white" />
            <rect x={maskWidth} y="0" width="18" height="18" fill="black" />
          </mask>
        </defs>
      )}
      <path
        d="M8.90706 0.574219L11.0097 7.01063H17.8125L12.3093 10.9899L14.4119 17.4263L8.90706 13.447L3.40222 17.4263L5.50483 10.9899L0 7.01063H6.80445L8.90706 0.574219Z"
        fill="#D9D9D9"
      />
      <path
        d="M8.90706 0.574219L11.0097 7.01063H17.8125L12.3093 10.9899L14.4119 17.4263L8.90706 13.447L3.40222 17.4263L5.50483 10.9899L0 7.01063H6.80445L8.90706 0.574219Z"
        fill="currentColor"
        mask={maskWidth && 'url(#half)'}
      />
    </svg>
  )
}

export default StarIcon
